import React from 'react';
import '../css/Contactushome.css';

function ContactusHome() {
  return (

<div className='bgcontact'>
    <div className="conthome-container container">

    <div className="text-center mb-3">
            <h2 className="fw-bold display-6 text-gradient">
              <span className="position-relative" style={{color:'rgb(2, 58, 58)'}}>
                Contact Us
                <span className="position-absolute bottom-0 start-50 translate-middle-x bg-primary" 
                  style={{ 
                    height: '4px', 
                    width: '80px', 
                    borderRadius: '2px'
                  }}></span>
              </span>
            </h2>
          </div>
          <br></br>
          
      <div className="row justify-content-end">

        {/* Contact Form */}
        <div className="col-lg-4">
          <div className="conthome-form-card p-4 h-100 position-relative overflow-hidden">
            {/* Border Animation Elements */}
            <div className="border-animation border-animation-top"></div>
            <div className="border-animation border-animation-right"></div>
            <div className="border-animation border-animation-bottom"></div>
            <div className="border-animation border-animation-left"></div>

            <form className="conthome-form position-relative">
              <div className="conthome-form-group mb-4">
                <input type="text" id="name" className="w-100" required />
                <label htmlFor="name">Your Name</label>
                <div className="conthome-form-bar"></div>
              </div>

              <div className="conthome-form-group mb-4">
                <input type="email" id="email" className="w-100" required />
                <label htmlFor="email">Your Email</label>
                <div className="conthome-form-bar"></div>
              </div>

              <div className="conthome-form-group mb-4">
                <input type="text" id="subject" className="w-100" required />
                <label htmlFor="subject">Subject</label>
                <div className="conthome-form-bar"></div>
              </div>

              <div className="conthome-form-group mb-4">
                <textarea id="message" className="w-100" required></textarea>
                <label htmlFor="message">Message</label>
                <div className="conthome-form-bar"></div>
              </div>

              <button type="submit" className="conthome-submit-btn">
                <span>Send Message</span>

              </button>
            </form>
          </div>
        </div>
        {/* Contact Info Cards */}
        <div className="col-lg-4">

          <div className="conthome-info-card row g-4 p-4 h-100">
            {/* Address Card */}
            <div className="col-lg-12 col-sm-7 conthome-info-item">
              <div className="d-flex h-100">
                <div className="conthome-icon-circle me-4">
                  <svg className="conthome-icon" viewBox="0 0 24 24">
                    <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
                  </svg>

                </div>
                <div className="conthome-info-text">
                  <h3>Email</h3>

                  <p>dashrath7865p@gmail.com</p>
             
                </div>
              </div>
            </div>

            {/* Phone Card */}
            <div className="col-lg-12 col-sm-6 conthome-info-item">
              <div className="d-flex h-100">
                <div className="conthome-icon-circle me-4">
                  <svg className="conthome-icon" viewBox="0 0 24 24">
                    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
                  </svg>
                </div>
                <div className="conthome-info-text">
                  <h3>Phone</h3>
                  <p>+91- 8180090266 <span style={{ color: 'transparent' }}>___________</span></p>
                 
                </div>
              </div>
            </div>

            {/* Video Card */}


            {/* Email Card */}
            <div className="col-lg-12 col-sm-6 conthome-info-item">
              <div className="d-flex h-100">
                <div className="conthome-icon-circle me-4">

                  <svg className="conthome-icon" viewBox="0 0 24 24">
                    <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
                  </svg>
                </div>
                <div className="conthome-info-text">
                  <h3>Address</h3>
                  <p>    A-54 MIDC karad Tal-karad Dist-satara ,415110</p>
                
                
                </div>

              </div>
            </div>

            {/* Video Card */}
            {/* <div className="col-lg-6 col-sm-6 conthome-video-item">
              <div className="conthome-video-container h-100">
                <video className="conthome-video" autoPlay loop muted playsInline>
                  <source src={contactvd} type="video/mp4" />
                </video>
              </div>
            </div> */}



          </div>
        </div>


      </div>
    </div>
</div>
  );
}

export default ContactusHome;